import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GLOBAL_CART_FEATURE_NAME } from './feature-name';
import { GlobalCartState } from './state';
import { CartState } from './cart';
import { COUNTER_UPPER_LIMIT } from '~shared/modules/shopping-cart-global/constants';

export const getCartGlobalModuleState = createFeatureSelector(GLOBAL_CART_FEATURE_NAME);

export const getCartState = createSelector(getCartGlobalModuleState, (state: GlobalCartState) => state && state.cart);

export const getCartPayload = createSelector(getCartState, (state: CartState) => state && state.payload);
export const getCartTotalQuantity = createSelector(
  getCartPayload,
  payload => (payload && payload.itemsInCart) >= COUNTER_UPPER_LIMIT
    ? `${COUNTER_UPPER_LIMIT - 1}+`
    : payload.itemsInCart
);
export const isCartLoading = createSelector(getCartState, (state: CartState) => state && state.loading);

export const showMiniCart = createSelector(getCartState, (state: CartState) => state && state.showMiniCart);

export const getCartError = createSelector(getCartState, (state: CartState) => state && state.error);
